import script from "./WordListEntryDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./WordListEntryDetails.vue?vue&type=script&setup=true&lang=js"

import "./WordListEntryDetails.vue?vue&type=style&index=0&id=d5634a68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5634a68"]])

export default __exports__